/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input ,ViewChild} from '@angular/core';
import { SidenavMenuService } from '../sidenav-menu/sidenav-menu.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { environment } from '../../../../environments/environment';
import { ListsService } from 'src/core/lists/lists.service';

import { MatMenuTrigger } from '@angular/material/menu';



@Component({
  selector: 'app-spurt-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent implements OnInit {

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  public category = { name: 'Select Category' };
  @Input() categories: any;
  searchValue: any = '';
  public imageUrl: any;
  public headerValue = environment.storename;
  public HeaderData: any;
  public HeaderImgae = [];
  public image: any;
  searchGroup: FormGroup;
  Category: any;
  public col1_co_categories = [];
  public col2_co_categories = [];
  public col3_co_categories = [];
  public co_categories = [];
  public index: number;
  public categoryId: string;
  public recheckIfInMenu: boolean;
  special_category: any;
menu: any;

  constructor(
    public sidenavMenuService: SidenavMenuService,
    public router: Router,
    public formBuilder: FormBuilder,
    public listSandbox: ListsSandbox,
    private api: ListsService
  ) { }

  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    // this.headerValue = environment.storename;
    this.listSandbox.getSettings();
    this.Header(this.headerValue);
    this.GetSettings();
    this.searchForm();
    this.getCategories()
  }
  // seacrh the data in the product list
 
  public getCategories() {
        
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.sortOrder = '';
    // this.listSandBox.getCategoryList(params);
    this.api.getCategoryList(params).subscribe((res: any) => {
        this.Category = res.data;
        for (let categoryItem of this.Category ){
          console.log("test" ,categoryItem )
          if(categoryItem.categorySlug == 'special-deals' ){
           
             this.special_category = categoryItem
             console.log("find the one ite,", this.special_category)
             
      

          }

        }
        console.log("final data",this.Category)
        })
        
        
      }

      openResourceMenu(index, id,image,image_path) {
      
        this.col1_co_categories = [];
        this.col2_co_categories = [];
        this.col3_co_categories = [];
        this.co_categories =[];

    if (this.categories && this.categories[index] && this.categories[index].children && this.categories[index].children.length > 0) {

        
        this.index = index;
        this.categoryId = id;

        this.co_categories = this.categories[index].children;


        var row = Math.floor(this.co_categories.length / 3)
        var remaining_row = this.co_categories.length % 3

        let f1 = row+(remaining_row>=1?1:0)    
        this.col1_co_categories = this.co_categories.slice(0,f1);
        let f2 = f1+row+(remaining_row>1?1:0)    
        this.col2_co_categories = this.co_categories.slice(f1, f2);
        let f3 = f2+row    
        this.col3_co_categories = this.co_categories.slice(f2, f3);



        setTimeout(() => {
            if (this.recheckIfInMenu === true && this.co_categories.length>0) {
                this.trigger.openMenu();
                // this.openMegaMenu();
            }
        }, 300);
        // this.trigger.openMenu();
        // this.openMegaMenu();
        
    } else {
        this.trigger.closeMenu();
        // this.openMegaMenu();
        return;
    }
}

over() {
  // console.log('cate',this.categories)
  // console.log('this.recheckIfInMenu',this.recheckIfInMenu)
  setTimeout(() => {
      if (this.recheckIfInMenu === false) {
          this.trigger.closeMenu();
      }
  }, 175);
}

  searchForm() {
    this.searchGroup = this.formBuilder.group({
      searchTerm: [''],
    });
    const searchEvent = this.searchGroup.controls.searchTerm.valueChanges.pipe().subscribe((val) => this.searchData(val));
     
  }

  public searchData(value) {
     
    this.searchValue = value;
    if (!value) {
      this.router.navigate(['/products'], {
        queryParams: { keyword: this.searchValue }
      });
    } else {
      this.router.navigate(['/products'], {
        queryParams: { keyword: this.searchValue }
      });
    }
  }

  public search() {
    
    this.router.navigate(['/products'], {
      queryParams: { keyword: this.searchValue }
    });
    
  }
  // select the product from product list
  public changeCategory(event) {
    if (event) {
      this.router.navigate(['/products/', event]);
    }
    if (window.innerWidth < 960) {
      this.stopClickPropagate(event);
    }
  }
  // style purpose
  public stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }
  // style purpose
  public closeSubMenus() {
    localStorage.setItem('specialdeal','0')
    if (window.innerWidth < 960) {
      this.sidenavMenuService.closeAllSubMenus();
    }
  }

  Header(i) {
    console.log("testingiddddphone",i)
    const data = {
      headerId: i
    };
    this.api.getBannerList(data).subscribe((res: any) => {
      this.HeaderData = res.data;
      console.log('Header-->',this.HeaderData)
    });
  }

  // Get Settings
  GetSettings() {
    this.api.getsettings()
      .subscribe((res: any) => {
        this.HeaderImgae = res.data;
        // if(this.headerValue=='220 Volt'){
        //   this.image = this.imageUrl + '?path=' + this.HeaderImgae[1].storeLogoPath + '&name=' + this.HeaderImgae[1].storeLogo
        // }else{
        this.image = this.imageUrl + '?path=' + this.HeaderImgae[0].storeLogoPath + '&name=' + this.HeaderImgae[0].storeLogo;
        // }
      });
  }

  importLocalTrack(){
    localStorage.setItem("specialdeal",'0')
  }

  importLocal(){
 
    localStorage.setItem("specialdeal",'1')

  }
}
